__turbopack_context__.v({
  "spin": "Spinner-module__vcbswa__spin",
  "spinner": "Spinner-module__vcbswa__spinner",
});
